import React, {FC} from "react";
import {Typography} from "antd";
import {useRegistrationCopy} from "./registrationCopy";
import type {PublicRegistrationSubmissionContext} from "./types";

export const sumSummaryItems = (items: PublicRegistrationSubmissionContext["summaryItems"]): number =>
    items.reduce((total, item) => total + item.amount, 0);

// What the participant submitted: who, which payable items, and the total.
export const PaymentSummary: FC<{context: PublicRegistrationSubmissionContext}> = ({context}) => {
    const {labels, formatAmount} = useRegistrationCopy();

    return (
        <section
            className="public-registration-result-summary"
            aria-labelledby="public-registration-summary-title"
        >
            <Typography.Title level={3} id="public-registration-summary-title">
                {labels.submissionSummary}
            </Typography.Title>
            <dl className="public-registration-result-details">
                <div>
                    <dt>{labels.participant}</dt>
                    <dd>{context.participantName}</dd>
                </div>
                <div>
                    <dt>{labels.email}</dt>
                    <dd>{context.email}</dd>
                </div>
            </dl>

            <Typography.Text strong>{labels.selectedItems}</Typography.Text>
            {context.summaryItems.length > 0 ? (
                <>
                    <ul className="public-registration-result-items">
                        {context.summaryItems.map((item, index) => (
                            <li key={`${item.label}-${index}`}>
                                <span>{item.label}</span>
                                <strong>{formatAmount(item.amount)}</strong>
                            </li>
                        ))}
                    </ul>
                    <div className="public-registration-result-total">
                        <span>{labels.totalAmount}</span>
                        <strong>{formatAmount(sumSummaryItems(context.summaryItems))}</strong>
                    </div>
                </>
            ) : (
                <Typography.Paragraph className="public-registration-result-empty">
                    {labels.noSelectedItems}
                </Typography.Paragraph>
            )}
        </section>
    );
};
